import axios from "axios";

const SplashPageService = {

    getAll: async function (filters) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages?'+filters)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                pages: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    getOne: async function (splashPageId) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/splash_pages/${splashPageId}`)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                page: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    create: async function (params) {
        try {
            const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages/', params)
            return response.data.data;
        } catch (e) {
            console.log(e);
            return {
                page: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    update: async function (splashPageId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages/' + splashPageId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                page: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    updateConfig: async function (optionId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages/configs/' + optionId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    createDisplaySettings: async function (params) {
        try {
            const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages/display_settings', params)
            return response.data.data;
        } catch (e) {
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    deletePage: async function (splashPageId) {
        if (confirm("Are you sure you want to delete this page?.")) {
            try {
                const response = await axios.delete(process.env.VUE_APP_SERVER_URL + `/api/v1/splash_pages/${splashPageId}`)
                return response.data.data.message
            } catch (e) {
                console.log(e.message);
                return {
                    page: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    },

    publishPage: async function (splashPageId) {
        if (confirm("Are you sure you want to publish this page?. All changes will be available to customers")) {
            try {
                const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/splash_pages/publish/${splashPageId}`)
                return response.data.data
            } catch (e) {
                console.log(e.message);
                return {
                    page: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    },
    cloneTemplate: async function (splashPageId, templateId) {
        if (confirm("Are you sure you want to copy this template?.")) {
            try {
                const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/splash_pages/copy/${splashPageId}?template=${templateId}`)
                return response.data.data
            } catch (e) {
                console.log(e.message);
                return {
                    page: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    }
};

export default SplashPageService;